import React from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid
} from '@mui/material';
import { ActorStageName } from 'generated/graphql';
import {
  appEvents,
  fields
} from 'modules';

import * as dataService from './dataService';



const ControlledTextField = fields.genTextFieldControllerComponent<dataService.IFormData>();

export interface IProps {
  actorStageName: ActorStageName;
}

export const FC: React.FC<IProps> = props => {
  const { form, loading, mutations } = dataService.useEditActorStageModal(props.actorStageName);



  async function handleSubmit(data: dataService.IFormData) {
    try {
      await mutations.overrideActorStageDisplayNameMutation(data);
      appEvents.broadcast({
        type: 'modal',
        args: 'close'
      });

    } catch (e) {
      alert(e);
    } finally {
      handleClose();
    }
  }



  function handleClose() {
    appEvents.broadcast({
      type: 'modal',
      args: 'close'
    });
  }



  return (
    <Dialog
      open
      onClose={handleClose}
      maxWidth="xs">
      <DialogTitle>Edit Stage</DialogTitle>

      <form onSubmit={form.handleSubmit(handleSubmit)}>
        <DialogContent>
          <Grid container rowSpacing={2} spacing={2}>
            <Grid item xs={12}>
              <ControlledTextField
                formControl={form.control}
                label="Stage Name"
                fieldKey="overrideDisplayName" />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button
            disabled={loading}
            variant="outlined"
            color="secondary"
            onClick={handleClose}>
              Cancel
          </Button>

          <Button
            type="submit"
            disabled={loading}>
              Confirm
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};
